export interface TemplateHSMTableI {
  category: string;
  type: TemplateTypeEnum;
  components: TemplateComponent[];
  language: string;
  name: string;
  namespace: string;
  rejected_reason: string | null;
  status: string;
  _id?: string;
}

interface TemplateComponent {
  format?: string;
  text?: string;
  type: string;
  buttons?: TemplateButton[];
}

export interface TemplateButton {
  text: string;
  type: string;
  url?: string;
  phone_number?: string;
  flow_id?: string;
  flow_action?: 'navigate' | 'data_exchange';
  navigate_screen?: string;
}

export enum TemplateHeaderEnum {
  AUDIO = 'audio',
  VIDEO = 'video',
  DOCUMENT = 'document',
  TEXT = 'text',
  IMAGE = 'image',
}

export enum TemplateButtonTypeEnum {
  QUICK_REPLY = 'QUICK_REPLY',
  URL = 'URL',
  PHONE_NUMBER = 'PHONE_NUMBER',
  CATALOG = 'CATALOG',
  MPM = 'MPM',
  VOICE_CALL = 'VOICE_CALL',
  FLOW = 'FLOW',
}

export enum TemplateTypeEnum {
  HSM = 'hsm',
  SMS = 'sms',
  EMAIL = 'email',
}
